/**
 * Research role catalog for clinical trials — legacy RoleConst [s.12–13],
 * frozen as a CODE CONSTANT (no DB table; decision 2026-09-21).
 *
 * When `role_code` references a constant below, the service copies
 * name/shortcut/site_staff from it and LOCKS those fields (REQ-020/021) —
 * only `comments` stays editable.
 *
 * 8 roles, values verbatim from legacy:
 *   site staff (SiteStaff=true):  INV, SN, SC, UP, IA
 *   external (SiteStaff=false):   CRA, unCRA, MM
 */
export const TRIAL_ROLE_CONSTANTS = {
    INV: {
        code: 'INV',
        name: 'Investigator',
        shortcut: 'INV',
        siteStaff: true,
    },
    SN: {
        code: 'SN',
        name: 'Study Nurse',
        shortcut: 'SN',
        siteStaff: true,
    },
    SC: {
        code: 'SC',
        name: 'Study Coordinator',
        shortcut: 'SC',
        siteStaff: true,
    },
    UP: {
        code: 'UP',
        name: 'Unblinded Pharmacist',
        shortcut: 'UP',
        siteStaff: true,
    },
    IA: {
        code: 'IA',
        name: 'Independent Assessor',
        shortcut: 'IA',
        siteStaff: true,
    },
    CRA: {
        code: 'CRA',
        name: 'Clinical Research Associate',
        shortcut: 'CRA',
        siteStaff: false,
    },
    UNBLINDED_CRA: {
        code: 'unCRA',
        name: 'Unblinded Clinical Research Associate',
        shortcut: 'unCRA',
        siteStaff: false,
    },
    MM: {
        code: 'MM',
        name: 'Medical Monitor',
        shortcut: 'MM',
        siteStaff: false,
    },
};
export const TRIAL_ROLE_CODES = Object.keys(TRIAL_ROLE_CONSTANTS);
export function getTrialRole(code) {
    return TRIAL_ROLE_CONSTANTS[code];
}
//# sourceMappingURL=trial-roles.js.map